import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import App from "./App";
import ThemeProvider from "@/components/theme-provider";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
      <Toaster
        theme="system"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "color-mix(in oklch, var(--popover) 92%, transparent)",
            color: "var(--popover-foreground)",
            border: "1px solid var(--glass-border)",
            backdropFilter: "blur(16px) saturate(180%)",
            WebkitBackdropFilter: "blur(16px) saturate(180%)",
            borderRadius: "16px",
            boxShadow: "var(--glass-shadow-strong)",
            fontSize: "12px",
          },
        }}
      />
    </ThemeProvider>
  </StrictMode>
);
